const apiKey = "AIzaSyAnAG3AuKu6VcpTlJDltwaVis7_6pSDvJI";

export const googleTranslate = require("google-translate")(apiKey);
